var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/microphone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/microphone_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 17.8337C14.7583 17.8337 17 15.592 17 12.8337V8.66699C17 5.90866 14.7583 3.66699 12 3.66699C9.24167 3.66699 7 5.90866 7 8.66699V12.8337C7 15.592 9.24167 17.8337 12 17.8337Z",
    fill: "#0082CD",
    stroke: "#0082CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.5 11.167V12.8337C4.5 16.9753 7.85833 20.3337 12 20.3337C16.1417 20.3337 19.5 16.9753 19.5 12.8337V11.167",
    stroke: "#0082CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.59375 8.23364C11.0771 7.69198 12.6938 7.69198 14.1771 8.23364",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3594 10.7336C11.3594 10.4586 12.4177 10.4586 13.4177 10.7336",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeries);
export default __webpack_public_path__ + "static/media/series.eda45b8d614cbe26c77fec4ceb90d7b9.svg";
export { ForwardRef as ReactComponent };